// Backend currently returns English error strings (e.g. "Invalid
// credentials"). This util translates known errors to Chinese before
// they hit the UI. Anything we haven't mapped falls back to a generic
// Chinese message and logs the original string so devs can spot it.
//
// Long-term: backend should return error codes (e.g. INVALID_CREDENTIALS)
// rather than human strings; this mapping survives that transition
// because it matches by lowercased substring and code keys both work.

const EXACT_MAP: Record<string, string> = {
    // Login / credential
    'invalid credentials':                       '手机号或密码错误',
    'account is not active':                     '账号未激活或已被禁用',
    'account is suspended':                      '账号已被暂停',
    'account is disabled':                       '账号已被禁用',
    'invalid phone number format':               '手机号格式不正确',
    'invalid or expired verification code':      '验证码错误或已过期',
    'phone and password are required':           '请填写手机号和密码',
    'phone and code are required':               '请填写手机号和验证码',
    'login failed':                              '登录失败，请稍后重试',
    'failed to create user account':             '账号创建失败，请稍后重试',
    'wechat login is not implemented yet':       '微信登录暂未开放',

    // Captcha / verification code
    'invalid scene':                             '验证场景无效',

    // Tokens
    'invalid token':                             '登录已失效，请重新登录',
    'invalid refresh token':                     '登录已过期，请重新登录',
    'invalid admin token':                       '管理员令牌无效',
};

const SUBSTRING_MAP: Array<[RegExp, string]> = [
    // For richer messages that include dynamic bits.
    [/invalid credentials/i,         '手机号或密码错误'],
    [/invalid or expired/i,          '验证码错误或已过期'],
    [/invalid phone/i,               '手机号格式不正确'],
    [/account is not active|suspended|disabled/i, '账号无法登录，请联系客服'],
    [/network|timeout|fetch/i,       '网络异常，请稍后重试'],
];

/**
 * Translate a backend error message to Chinese for display.
 *
 * @param raw   The raw error string from the backend (or an exception message).
 * @param fallback  Used when the message is empty or unknown. Defaults to a
 *                  generic Chinese message so we never surface English.
 */
export function translateBackendError(raw: string | undefined | null, fallback = '操作失败，请稍后重试'): string {
    if (!raw) return fallback;
    const trimmed = raw.trim();
    if (!trimmed) return fallback;

    const exact = EXACT_MAP[trimmed.toLowerCase()];
    if (exact) return exact;

    for (const [pattern, zh] of SUBSTRING_MAP) {
        if (pattern.test(trimmed)) return zh;
    }

    // No mapping — if the message contains any Chinese characters we
    // assume the backend already localized it; otherwise fall back to
    // a generic Chinese message and log so we can fix it later.
    if (/[一-鿿]/.test(trimmed)) return trimmed;

    if (typeof console !== 'undefined' && console.warn) {
        console.warn('[i18n] untranslated backend error:', trimmed);
    }
    return fallback;
}
